var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.115479,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#5C9673"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8515 8.45725C26.9746 9.13483 27.3358 10.5947 26.6583 11.7178L18.7675 24.7989C17.1466 27.4852 13.4815 27.9607 11.3145 25.5622C11.2408 25.4805 11.1728 25.3939 11.111 25.3028L8.40953 21.3185C7.6734 20.2329 7.95669 18.7559 9.04228 18.0197C10.1279 17.2835 11.6047 17.5669 12.3408 18.6525L14.7683 22.2327L22.5912 9.26408C23.2687 8.14089 24.7284 7.77966 25.8515 8.45725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/okIcon.9a0b8790d0cdacb55f361170f85f36e5.svg";
export { ForwardRef as ReactComponent };